import axios from "axios";
const jsonConfig = require("../../Config.json");
const assessmentprofile = async (payload) => {
  try {
    const response = await axios.post(
      `${jsonConfig.apiUrl}assessment/profile`,
      payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export default assessmentprofile;